import * as Sentry from '@sentry/react';

export function capture(error: unknown) {
    console.error(error);
    Sentry.captureException(error);
}
